import { Helmet } from 'react-helmet-async';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DELEGON_URL } from 'configuration';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from 'i18n/config';

// hreflang: whether to list the page's other language versions. Pass false for pages whose
// content isn't translated (only the UI around it is), e.g. public profiles, blog posts and
// job ads, which instead get a single canonical language version from the backend.
export const Head = ({ title = '', meta = [], hreflang = true }) => {
  const location = useLocation();
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const pathWithoutLocale = lang ? location.pathname.replace(`/${lang}`, '') : null;

  return (
    <Helmet /* title={'Delegon' + (title ? ' | ' + title : '')} */>
      {/* Routes without a /:lang URL segment (e.g. /auth/*) still reflect
          the live i18n language here, since there's no route param to derive it from. */}
      <html lang={lang || i18n.language} />
      <title>Delegon  | {title}</title>
      {meta.map(({ name = '', content = '', property = '' }) => (
        <meta name={name} content={content} property={property} key={name || property} />
      ))}
      {lang && hreflang && SUPPORTED_LOCALES.map((l) => (
        <link rel="alternate" hrefLang={l} href={`${DELEGON_URL}/${l}${pathWithoutLocale}`} key={l} />
      ))}
      {lang && hreflang && (
        <link rel="alternate" hrefLang="x-default" href={`${DELEGON_URL}/${DEFAULT_LOCALE}${pathWithoutLocale}`} />
      )}
    </Helmet>
  );
};
